import { render } from "./FloorAreaPanel.vue?vue&type=template&id=945ff368&scoped=true"
import script from "./FloorAreaPanel.vue?vue&type=script&lang=js"
export * from "./FloorAreaPanel.vue?vue&type=script&lang=js"

import "./FloorAreaPanel.vue?vue&type=style&index=0&id=945ff368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945ff368"]])

export default __exports__